import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { nivelDificuldadeAdapter } from "@/data";
import { toast } from "@/hooks/use-toast";
import type { NivelDificuldade } from "@/types/tabelas-auxiliares";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  item: NivelDificuldade | null;
  onSuccess: () => void;
}

export function NivelDificuldadeDeleteDialog({ open, onOpenChange, item, onSuccess }: Props) {
  const handleConfirm = async () => {
    if (!item || item.sistema) return;
    try {
      await nivelDificuldadeAdapter.delete(item.id_nivel_dificuldade);
      toast({ title: "Sucesso", description: "Nível de dificuldade excluído com sucesso!" });
      onSuccess();
      onOpenChange(false);
    } catch (error) {
      toast({ title: "Erro", description: "Não foi possível excluir.", variant: "destructive" });
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Excluir Nível de Dificuldade</AlertDialogTitle>
          <AlertDialogDescription>
            {item?.sistema ? "Registros de sistema não podem ser excluídos." : `Tem certeza que deseja excluir permanentemente "${item?.nome}"? Esta ação não pode ser desfeita.`}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm} disabled={item?.sistema}>Excluir</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
